import React from "react";
import { Navigate, Outlet, Route, Routes } from "react-router-dom";
import { BannerImage } from "./BackEnd/Masters/BannerImage/BannerImage";
import { TopBrand } from "./BackEnd/Masters/TopBrand/TopBrand";
import { Promotion } from "./BackEnd/Masters/Promotion/Promotion";
import { UserRegistration } from "./BackEnd/Masters/UserRegistration/UserRegistration";
import { BannerImageList } from "./BackEnd/Masters/BannerImage/BannerImageList";
import { TopBrandList } from "./BackEnd/Masters/TopBrand/TopBrandList";
import { PromotionList } from "./BackEnd/Masters/Promotion/PromotionList";
import { Supplier } from "./BackEnd/Masters/Supplier/Supplier";
import { ReconciliationList } from "./BackEnd/Masters/Supplier/ReconciliationList";
import { FinancialDashboard } from "./BackEnd/Dashboard/FinancialDashboard";
import { SupplierList } from "./BackEnd/Masters/Supplier/SupplierList";
import { BillList } from "./BackEnd/Bill/BillList";
import { Bill } from "./BackEnd/Bill/Bill";
import { ActionReconcilationOrChequeList } from "./BackEnd/Masters/Supplier/ActionReconcilationOrCheque";
import { ActionCheckIssuedOrNo } from "./BackEnd/Masters/CheckIssued/ActionCheckIssuedOrNo";
import { UserList } from "./BackEnd/Masters/UserRegistration/UserRegistrationList";
import ImportBill from "./BackEnd/Bill/ImportBill";

interface PrivateRouteProps {
  token: string | null;
}

const PrivateRoute: React.FC<PrivateRouteProps> = ({ token }) => {
  if (!token) {
    return token ? <Outlet /> : <Navigate to="/login" />;
  }

  return (
    <Routes>
      {/* <Route path="/" element={<Layout />}/> */}
      <Route path="/home" element={<FinancialDashboard />} />

      {/* banner management */}
      <Route
        path="/banner/list"
        element={<BannerImageList id="bannerList" />}
      />
      <Route path="banner/create" element={<BannerImage />} />
      <Route path="/banner/:id" element={<BannerImage />} />

      {/* brand management */}
      <Route path="/brand/list" element={<TopBrandList id="brandList" />} />
      <Route path="brand/create" element={<TopBrand />} />
      <Route path="/brand/:id" element={<TopBrand />} />

      {/* promotion management */}
      <Route
        path="/promotion/list"
        element={<PromotionList id="promotionList" />}
      />
      <Route path="promotion/create" element={<Promotion />} />
      <Route path="/promotion/:id" element={<Promotion />} />

      {/* supplier management */}
      <Route
        path="/supplier/list"
        element={<SupplierList id="supplierlist" />}
      />
      <Route path="supplier/create" element={<Supplier id="add-supplier" />} />
      <Route path="/supplier/:id" element={<Supplier id="edit-supplier" />} />

      {/* bill management */}
      <Route path="/bill/list" element={<BillList id="billList" />} />
      <Route path="bill/create" element={<Bill id="add-bill" />} />
      <Route path="/bill/:id" element={<Bill id="edit-bill" />} />

      {/* user management */}
      <Route path="user/create" element={<UserRegistration />} />
      <Route path="/user/:id" element={<UserRegistration />} />
      <Route path="/user/list" element={<UserList />} />

      <Route
        path="/actions/list"
        element={
          <ActionReconcilationOrChequeList id="actionReconcilationOrCheque-bill" />
        }
      />
      <Route
        path="/reconciliation/list"
        element={<ReconciliationList id="reconciliation-bill" />}
      />
      <Route
        path="/chequeissue/list"
        element={<ReconciliationList id="reconciliation-bill" />}
      />

      <Route
        path="/chequeIssue/actions/list"
        element={<ActionCheckIssuedOrNo id="actionChequeIssuedOrNotIssued" />}
      />
      <Route
        path="/bill/import"
        element={<ImportBill />}
      />
    </Routes>
  );
};

export default PrivateRoute;
